export enum Status {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INDEXED = 'INDEXED'
}
